import React from 'react';
import { observer, inject } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';
import PropTypes from 'prop-types';

import DocumentHead from 'legacyComponents/documentHead';
import { Loading } from 'libs/rendering/gltf/components/loading';
import {
  MainWrapper,
  IssueWrapper as ContributionWrapper,
  CrumbsWrapper,
} from 'legacyComponents/styled/lib';

import { FourOhFour } from 'apps/fourOhFour/index';
import { clientStore } from 'apps/client/app';
import { DirLink, DirName } from 'apps/repository/styles';
import { mapToObject } from 'apps/utils';
import { imageSrc } from 'apps/file/utils';

import { ContributionPageAppManager } from 'apps/repository/contributionPage/appManager';
import { ContributionPageContent } from 'apps/repository/contributionPage/views/contributionPageContent';
import { ContributionPageStats } from 'apps/repository/contributionPage/views/contributionPageStats';

import { conf as globalConf } from 'apps/config.yaml';

@withNamespaces()
@inject('routerStore')
@observer
export class ContributionPage extends React.Component {
  UNSAFE_componentWillMount() {
    this.appManager = new ContributionPageAppManager(null, this.props);
  }

  render() {
    const projectRoute = `${clientStore.spaceRoute.route}`;
    const { project, routerStore } = this.props;

    const routeParams = mapToObject(routerStore.params);
    const projectRouteParams = Object.assign({}, routeParams, {
      fragment: 'history',
    });
    delete projectRouteParams.contributionId;

    if (this.appManager.loading) {
      return <Loading visible noText />;
    }
    if (
      this.appManager.queries.get('contributionPage')?.notFound ||
      this.appManager.contributionPage === null
    ) {
      return <FourOhFour type='Issue Page' />;
    }

    const { contributionPage } = this.appManager;
    const version = contributionPage.version.substring(0, 7);

    const { params } = routerStore.route;
    params.contributionId = contributionPage.version;
    const canonicalPath = routerStore.router.buildUrl(
      routerStore.route.name,
      params,
    );

    return (
      <React.Fragment>
        <DocumentHead
          title={`${contributionPage.title} - ${project.name}`}
          description={contributionPage.description}
          canonicalPath={canonicalPath}
          imagePath={imageSrc(
            project.image,
            '',
            globalConf.imgSizes.project.large,
          )}
        />
        <MainWrapper>
          <CrumbsWrapper>
            <DirLink
              name={`${projectRoute}.files`}
              params={projectRouteParams}
              first
            >
              <Trans>All Contributions</Trans>
            </DirLink>
            <DirName>&nbsp;/&nbsp;</DirName>
            <DirName>#{version}</DirName>
          </CrumbsWrapper>
          <ContributionWrapper>
            <ContributionPageContent contribution={contributionPage} />
            <ContributionPageStats contribution={contributionPage} />
          </ContributionWrapper>
        </MainWrapper>
      </React.Fragment>
    );
  }
}

ContributionPage.propTypes = {
  params: PropTypes.object,
  project: PropTypes.object,
  routerStore: PropTypes.object,
  t: PropTypes.func,
};
